export const parseLangFromISO = (lang: string) => lang.replace(/-.*$/, '')
